import { AppUtils } from '../../shared/utils/index';
import { BasicApplicationUrlBuilder } from "./BasicApplicationUrlBuilder";

export class LegalCommercialService {
	private readonly options: MglAppOptions;
	private readonly $ctx: JQuery;
	private readonly urlBuilder: BasicApplicationUrlBuilder<MglAppDefinition>;

	constructor(options: MglAppOptions) {
		this.options = options;
		this.$ctx = this.options.$ctx;
		this.urlBuilder = new BasicApplicationUrlBuilder(options);
	}


	public checkBirthdate(dateOfBirthSelector: JQuery.Selector): void {
		const birthdateField = this.$ctx.find(dateOfBirthSelector),
			birthdate = (birthdateField.val() || "").toString();
		if (birthdate) {
			const longDate = AppUtils.Format.viewDateToIsoDate(birthdate);
			this.checkAgeStage(longDate);
		}
	}

	public checkAgeStage(birthdate: string): void {
		AppUtils.Ajax.fragment(
			{
				url: this.urlBuilder.fullUrl(this.options.app.apibirthdate),
				data: {
					Geburtsdatum: birthdate
				}
			},
			(successdata: ApiResponse<{ Stufe: number }>) => {
				this.updateCommercialNotice(successdata.Data.Stufe);
			},
			(jqxhr: JQueryXHR) => {
				this.updateCommercialNotice(0);
				AppUtils.Helper.logError(jqxhr, 'MembershipApplication', window.location.href, 'checkAgeStage');
			});
	}

	private updateCommercialNotice(stage: number): void {
		this.$ctx.find('.js-agecheck').toggleClass('h-hidden', 1 >= stage);
	}
}
